import { Breadcrumbs, ComparisonTable, NasCta, NasFeaturesgrid, HeroValueSection } from "@/components/features/Nas";
import Footer from "../../components/common/layout/Footer";
import SEO from "@/components/common/seo/seo";

export default function Nas() {
  return (
    <div>
      <SEO
        title="NAS Storage Solutions - SAN micron"
        description="Discover enterprise-grade NAS storage solutions from SAN micron. Secure, scalable, and cost-effective data infrastructure for businesses of all sizes."
      />
      <Breadcrumbs />
      {/* <NasDetail /> */}
      <HeroValueSection />
      <ComparisonTable />
      <NasFeaturesgrid />
      <NasCta />
      <Footer />
    </div>
  )
}